import { memo, useCallback, useMemo } from 'react';

import { Button, Flex, Input, Label, Text, TextField } from '@/components/core';
import { AddIcon, CloseIcon } from '@/components/icons';
import { useTriggerStore } from '@/store';
import { toString } from '@/utils';
import { VariablesMenu } from './VariablesMenu';

export type HttpUrlProps = {
  placeholder?: string;
  isDisabled?: boolean;
};

const IHttpUrl = ({ placeholder, isDisabled }: HttpUrlProps) => {
  const action = useTriggerStore((state) => state.action);
  const updateAction = useTriggerStore((state) => state.updateAction);

  const updateUrl = useCallback(
    (url: string) => {
      updateAction({ config: { ...action.config, url } });
    },
    [action.config, updateAction]
  );

  const variable = useMemo(() => {
    if (!action.config?.url) return undefined;
    const url = toString(action.config.url);
    const match = url.match(/^\$\{(.*)\}$/);
    return match ? match[1] : undefined;
  }, [action.config.url]);

  return (
    <Flex col className="gap-md">
      {variable ? (
        <div className="gap-xs flex flex-col">
          <Label isRequired>URL</Label>
          <div className="flex items-center rounded-md border border-gray-200 bg-white p-2">
            <div className="flex w-fit items-center rounded-sm border border-gray-200 bg-white pl-2 shadow-xs">
              <Text size="xs">{variable}</Text>
              <Button variant="plain" onPress={() => updateUrl('')}>
                <CloseIcon className="!size-2.5" />
              </Button>
            </div>

            <div className="grow" />

            <VariablesMenu onSelect={(id) => updateUrl(`\${${id}}`)} />
          </div>
        </div>
      ) : (
        <TextField onChange={updateUrl} value={toString(action.config?.url)} isDisabled={isDisabled}>
          <Label isRequired>URL</Label>
          <Input placeholder={placeholder}>
            <VariablesMenu onSelect={(id) => updateUrl(`\${${id}}`)} />
          </Input>
        </TextField>
      )}
    </Flex>
  );
};

export const HttpUrl = memo(IHttpUrl) as typeof IHttpUrl;
